// Human, Italian labels for the tenant roles. The role *values* stay the raw
// enum (the API contract); only what the user reads is translated — so the
// role <Select> options no longer expose `manager_hotel` & co.
export type TenantRole = "tenant_owner" | "manager_hotel" | "manager_functional" | "staff";

export const ROLE_LABEL: Record<TenantRole, string> = {
  // Aligned with ui-kit RoleBadge: "owner" is "Titolare", a manager is a
  // "Responsabile" — never the English mix the pre-v18 UI used.
  tenant_owner: "Titolare",
  manager_hotel: "Responsabile",
  manager_functional: "Responsabile funzionale",
  staff: "Staff",
};

/** Italian label for a role value, falling back to the raw value if unknown. */
export function roleLabel(role: string): string {
  return (ROLE_LABEL as Record<string, string>)[role] ?? role;
}

/** The roles in display order, for building <Select> options. */
export const ROLE_ORDER: ReadonlyArray<TenantRole> = [
  "staff",
  "manager_functional",
  "manager_hotel",
  "tenant_owner",
];
